module.exports = __webpack_public_path__ + "img/intervalsWork.c7ffacf2.png";